module.exports = __webpack_public_path__ + "static/media/2023-Sub-Exclusive-Feature-Banner-md@2x.0e15a9b5.webp";